module.exports = __webpack_public_path__ + "static/media/IMG_3495_sm.b2a9be75.jpg";